<template>
  <div>
    <el-button
      type="primary"
      size="small"
      plain
      @click="handleBind"
      :disabled="disabled"
      :loading="loading"
      >绑定三方账号</el-button
    >
    <el-dialog title="授权" destroy-on-close :visible.sync="showDialog">
      <div class="content">
        <div class="mask-content">
          <div class="mask"></div>
        </div>
        <iframe
          v-if="showDialog"
          class="iframe"
          :src="authUrl"
          frameborder="0"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getKuaishouAuthUrl, getKuaishouAuthState } from "@/api/team";
export default {
  props: {
    classId: String,
    disabled: Boolean,
  },
  data() {
    return {
      authUrl: "",
      authCode: "",
      showDialog: false,
      loading: false,
    };
  },
  watch: {
    showDialog(val) {
      this.timer && clearInterval(this.timer);
      if (val) {
        this.timer = setInterval(this.queryAuthState, 2000);
      }
    },
  },
  methods: {
    async handleBind() {
      await this.$confirm("即将跳转至授权页，确定要绑定吗？", {
        type: "warning",
      });
      try {
        this.loading = true;
        const res = await getKuaishouAuthUrl({ classId: this.classId });
        if (res.code == 0) {
          this.authUrl = res.data.url;
          this.authCode = res.data.code;
          this.showDialog = true;
        } else {
          this.$message.error(res.msg);
        }
      } finally {
        this.loading = false;
      }
    },
    //查询授权状态
    async queryAuthState() {
      const res = await getKuaishouAuthState({ code: this.authCode });
      if (res.code == 0) {
        if (res.data == 3) {
          this.$message.success("授权成功");
          this.$emit("onSuccess");
          this.showDialog = false;
          // clearInterval(this.timer);
        } else if (!res.data) {
          this.$message.warning("二维码已失效");
          this.showDialog = false;
        }
      } else {
        console.log(msg);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  position: relative;
  height: 574px;

  .iframe {
    width: 100%;
    height: 100%;
  }

  .mask-content {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    .mask {
      background-color: #fff;
      height: 70px;
      width: 300px;
    }
  }
}
</style>
